var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ranking-board"}},[_c('module-title',{attrs:{"title":"时段销售趋势"}}),_c('div',{staticStyle:{"width":"100%","height":"80%"},attrs:{"id":"myChart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }